import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import { IMyDpOptions, IMyDate, MyDatePicker } from 'mydatepicker';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdjustTimeService } from 'src/app/questionarie-signup/adjust-time.service';
import * as moment from 'moment-timezone';
@Component({
  selector: 'app-r-q3',
  templateUrl: './r-q3.component.html',
  styleUrls: ['./r-q3.component.css', '../residential-question.component.css'],
  // providers: [DatePipe],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class RQ3Component implements OnInit {
  @Input() data: any;
  @ViewChild('mydp', { static: true }) mydp: MyDatePicker;
  in_contract;
  emailObj = {
    emailId: '',
    text: '',
  };
  // API Url
  url = environment.api_url;
  date;
  hgContract;
  hgContractExpires;
  user_bot = false;
  ans_in_contract;
  ans_in_contract_expires;
  questions = [];
  userResponses = [];
  question;
  questionObj;
  index;
  showPicker = false;
  switchDate;
  dayString;
  deviceWidth;
  isChecked = false;
  model: any;
  modalVisible = false;
  myDatePickerOptions: IMyDpOptions;
  contractDate;
  xDays;
  newd;
  elem1;
  elem2;
  elem3;
  elem4;
  elem5;
  timer;
  isDisable = false;
  showbutton = true;
  isEdge = false;
  isChrome = false;
  isFirefox = false;
  switchedDate;
  switchedDatee;
  switchedDatee1;
  modalRef: BsModalRef;
  availDate;
  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };
  minDate: string;
  constructor(
    private residentialService: ResidentialService,
    private modalService: BsModalService,
    private router: Router,
    private http: HttpClient,
    private timeZoneService: AdjustTimeService
  ) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    this.hgContract = {
      value1: false,
      value2: false,
      value3: false,
    };
    this.hgContractExpires = {
      value4: false,
      value5: false,
    };
    // this.myDatePickerOptions = {
    //   // other options...
    //   dateFormat: 'mm/dd/yyyy',
    //   firstDayOfWeek: 'su',
    //   disableUntil: {
    //     year: new Date().getFullYear(),
    //     month: new Date().getMonth() + 1,
    //     day: new Date().getDate() - 1,
    //   },
    //   editableDateField: false,
    //   showClearDateBtn: false,
    //   showInputField: false,
    //   openSelectorOnInputClick: true,
    // };
    this.isEdge = JSON.parse(sessionStorage.getItem('browserType'));
    this.isChrome =
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }

  ngOnInit() {
    this.minDate = this.timeZoneService.updateTime('America/Chicago');
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.elem1 = document.getElementById('DontKnow_mob');
      this.elem2 = document.getElementById('AlreadyExpired_mob');
      this.elem3 = document.getElementById('Expires_mob');
    } else {
      this.elem1 = document.getElementById('DontKnow');
      this.elem2 = document.getElementById('AlreadyExpired');
      this.elem3 = document.getElementById('Expires');
    }
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ nextId: '0014' });
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }

    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        res_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        this.isChecked = true;
        this.in_contract = obj.fieldValue;
        if (this.in_contract === "I don't know") {
          this.setCheckboxElementsActive('check1', this.elem1);
          // this.hgContract = {
          //   value1: true,
          //   value2: false,
          //   value3: false,
          // };
          // this.elem1.parentElement.classList.add('active-select');
          // this.ans_in_contract = this.in_contract;
          // this.user_bot = true;
          // if (this.deviceWidth < 768) {
          //   this.goNext();
          // }
        } else if (this.in_contract === 'No, It already expired') {
          this.setCheckboxElementsActive('check2', this.elem2);
          // this.hgContract = {
          //   value1: false,
          //   value2: true,
          //   value3: false,
          // };
          // this.elem2.parentElement.classList.add('active-select');
          // this.ans_in_contract = this.in_contract;
          // this.user_bot = true;
          // if (this.deviceWidth < 768) {
          //   this.goNext();
          // }
        } else if (this.in_contract.value === 'Yes, it expires on') {
          this.setCheckboxElementsActive('check3', this.elem3);
          // this.hgContract = {
          //   value1: false,
          //   value2: false,
          //   value3: true,
          // };
          // this.elem3.parentElement.classList.add('active-select');
          if (typeof this.in_contract.date === 'string') {
            this.date =
              this.in_contract.date != undefined
                ? JSON.parse(this.in_contract.date)
                : '';
          } else {
            this.date = this.in_contract.date;
          }
          if (this.date) {
            if (typeof this.date === 'string') {
              this.date = new Date(this.date);
            }
            // this.model = {
            //   date: {
            //     year: this.date.getFullYear(),
            //     month: this.date.getMonth() + 1,
            //     day: this.date.getDate(),
            //   },
            // };
            this.model = this.date;
            this.contractDate = this.model;
            // this.pad(this.model.date.month) +
            // '/' +
            // this.model.date.day +
            // '/' +
            // this.model.date.year;
            this.ans_in_contract =
              this.in_contract.value +
              ' ' +
              this.dateObjectCstFormatted(this.contractDate);
            // this.user_bot = true;
            this.showPicker = true;
            // if (this.deviceWidth < 768) {
            //   this.goNext();
            // }
          }
        }
      }
    }

    if (this.deviceWidth < 768)
    {}else
    {
      if(!this.hgContract.value1 && !this.hgContract.value2 && !this.hgContract.value3)
      {
        this.showbutton = false;
      }
    }


   
  }

  setCheckboxElementsActive(itemValue, item) {
    this.hgContract =
      itemValue === 'check1'
        ? {
            value1: true,
            value2: false,
            value3: false,
          }
        : itemValue === 'check2'
        ? {
            value1: false,
            value2: true,
            value3: false,
          }
        : {
            value1: false,
            value2: false,
            value3: true,
          };
    item.parentElement.classList.add('active-select');
    this.ans_in_contract = this.in_contract;
    this.user_bot = true;
    if (this.deviceWidth < 768) {
      this.goNext();
    }
  }

  onToggleSelector(event: any) {
    event.stopPropagation();
    this.mydp.openBtnClicked();
  }
  getIncontract(event) {
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
      if (event.target.value === "I don't know") {
        this.hgContract = {
          value1: true,
          value2: false,
          value3: false,
          value4: false,
        };
        this.elem1.parentElement.classList.add('active-select');
        if (_.contains(this.elem2.parentElement.classList, 'active-select')) {
          this.elem2.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.elem3.parentElement.classList, 'active-select')) {
          this.elem3.parentElement.classList.remove('active-select');
        }
        this.showPicker = false;
        this.date = '';
        this.ans_in_contract = event.target.value;
        this.user_bot = true;
        this.isDisable = false;

      
      } else if (event.target.value === 'No, It already expired') {
        this.hgContract = {
          value1: false,
          value2: true,
          value4: false,
        };
        this.elem2.parentElement.classList.add('active-select');
        if (_.contains(this.elem1.parentElement.classList, 'active-select')) {
          this.elem1.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.elem3.parentElement.classList, 'active-select')) {
          this.elem3.parentElement.classList.remove('active-select');
        }
        this.showPicker = false;
        this.date = '';
        this.ans_in_contract = event.target.value;
        this.user_bot = true;
        this.isDisable = false;
      

      } else {
        this.hgContract = {
          value1: false,
          value2: false,
          value3: true,
          value4: false,
        };
        this.elem3.parentElement.classList.add('active-select');
        if (_.contains(this.elem2.parentElement.classList, 'active-select')) {
          this.elem2.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.elem1.parentElement.classList, 'active-select')) {
          this.elem1.parentElement.classList.remove('active-select');
        }
      }
      // console.log.log("coming",event.target.value);

      if (event.target.value === "I don't know") {
      }

      if (event.target.value === 'Yes, it expires on') {
        this.showPicker = true;
        if (this.date === undefined || this.date === null) {
          this.in_contract = { value: event.target.value, date: '' };
          this.isChecked = false;
        } else {
          this.in_contract = { value: event.target.value, date: this.date };
        }
        if (_.isEmpty(this.model) || this.isDisable === true) {
          this.user_bot = false;
        } else {
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      } else {
        this.in_contract = event.target.value;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
      this.hgContract = {
        value1: false,
        value2: false,
        value3: false,
        value4: false,
      };
      this.in_contract = '';
      this.showPicker = false;
      this.user_bot = false;
      this.elem1.parentElement.classList.remove('active-select');
      this.elem2.parentElement.classList.remove('active-select');
      this.elem3.parentElement.classList.remove('active-select');
    }
    this.save();

    if (this.deviceWidth < 768) {}else
    {
      if(event.target.value === "I don't know" || event.target.value === 'No, It already expired')
      {
        if(!this.showbutton)
        {
          this.next();
        }
      }
     

    }
  }

  getDate() {
    if (!this.hgContract.value3) {
      this.hgContract = {
        value1: false,
        value2: false,
        value3: true,
      };
      this.isChecked = true;
    }
    // if (this.isEdge) {
    this.elem3.parentElement.classList.add('active-select');
    if (_.contains(this.elem2.parentElement.classList, 'active-select')) {
      this.elem2.parentElement.classList.remove('active-select');
    }
    if (_.contains(this.elem1.parentElement.classList, 'active-select')) {
      this.elem1.parentElement.classList.remove('active-select');
    }
    // }
    // this.date = new Date(this.model.formatted);
    this.date = this.model;

    this.checkExpiry(this.date);
    this.contractDate = this.dateObjectCstFormatted(this.model);
    // this.pad(this.model.date.month) +
    // '/' +
    // this.model.date.day +
    // '/' +
    // this.model.date.year;
    this.in_contract = {
      value: 'Yes, it expires on',
      date: JSON.stringify(this.date),
    };
    this.ans_in_contract =
      this.in_contract.value +
      ' ' +
      this.dateObjectCstFormatted(this.contractDate);
    // }

    if(this.deviceWidth < 768)
    {

    }else
    {
      if(!this.showbutton)
      {
        this.next();
      }
    }


  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  openEmailModalButton(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  openEmailModalSuucessButton(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  checkExpiry(date) {
    this.availDate = date;
    const exp_date = Number(date);
    const diff_days = (exp_date - Number(new Date())) / (1000 * 60 * 60 * 24);

    var dt = new Date(date);
    var subtractDate = dt.setDate(dt.getDate() - 13);
    this.switchedDate = new Date(subtractDate);

    //console.log("this.switchedDate....",this.switchedDate.toDateString().split(" "));
    var ds = this.switchedDate.toDateString().split(' ');
    this.switchedDatee = ds[1] + ' ' + ds[2] + ' ' + ds[3];
    var d = new Date(this.switchedDate.toDateString()),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    this.switchedDatee1 = [month, day, year].join('/');

    var newDate = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);

    let parseDate = newDate.toDateString();
    var splitDate = parseDate.split(' ');
    this.switchDate = splitDate[1] + ' ' + splitDate[2] + ' ' + splitDate[3];
    //// console.log.log(this.switchDate);
    let switchDate = this.switchedDate;
    this.newd = new Date();

    var newDate = new Date(Date.now() + (diff_days - 1) * 24 * 60 * 60 * 1000);
    this.newd = new Date();
    var Days = (this.switchedDate - Number(this.newd)) / (1000 * 60 * 60 * 24);
    this.xDays = parseInt(Days.toString().split('.')[0]);
    if (this.xDays == '1') {
      this.dayString = 'DAY';
    } else if (this.xDays == '0') {
      this.dayString = '';
    } else {
      this.dayString = 'DAYS';
    }
    if (diff_days > this.questionObj.hg_res_rules[0].parameter) {
      this.isDisable = true;
      this.user_bot = false;
      document.getElementById('openModalButton').click();
    } else {
      this.user_bot = true;
      this.isDisable = false;

      this.save();
      if (this.deviceWidth < 768) {
        this.goNext();
      }
    }
  }

  signUp() {
    this.residentialService.userResponse.userResponses.length = 3;
    // Adding quit flow logic
    const questionStatusObj = {
      questionStatus: 'Quitted',
      questionStep: this.residentialService.currentId,
      type: this.residentialService.service,
      percentage: null,
    };
    questionStatusObj.percentage = Number(sessionStorage.getItem('percentage'));
    sessionStorage.setItem(
      'questionStatusObj',
      JSON.stringify(questionStatusObj)
    );
    sessionStorage.setItem(
      'questionStatusObj',
      JSON.stringify(questionStatusObj)
    );
    this.router.navigateByUrl('/');
  }

  ignore() {
    this.isDisable = false;
    this.user_bot = true;
    if (this.deviceWidth < 768) {
      this.goNext();
    }
  }

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  next() {
    if (this.user_bot) {
      if (!this.in_contract) {
        if (this.deviceWidth < 768) {
          this.residentialService.unSelectService({ currentId: this.data });
        }
      } else if (this.in_contract.value === 'Yes, it expires on') {
        if (!this.model) {
          if (this.deviceWidth < 768) {
            this.residentialService.unSelectService({ currentId: this.data });
          }
        } else {
          this.ans_in_contract =
            this.in_contract.value +
            ' ' +
            this.dateObjectCstFormatted(this.contractDate);
          this.save();
          this.residentialService.messageService({ currentId: this.data });
        }
      } else {
        this.residentialService.messageService({ currentId: this.data });
      }
    }
  }

  userObj = {
    ignoreValue: '',
    reminder: '',
    type: 'contract',
  };

  contactObj = {
    ignoreValue: '',
    reminder: '',
  };
  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  emailcheckboxes = [
    {
      label: 'EMAIL',
      value: 'EMAIL',
    },
    {
      label: 'TEXT',
      value: 'TEXT',
    },
  ];

  closeEmailModel(myForm) {
    myForm.reset();
    this.modalRef.hide();
  }

  send(event, myForm, formValid, modalId) {
    if (myForm.form.value) {
      if (myForm.form.value.email != undefined) {
        const userResponses = {
          addAddress: myForm.form.value.email,
          phoneno: myForm.form.value.contactQues
            ? myForm.form.value.contactQues.replace(/[^\d]/g, '')
            : '',
          switchdays: this.xDays,
          switchDate: this.switchDate,
          switchedDatee: this.switchedDatee,
          switchedDate: this.availDate,
          questionId: '003',
          isExpired: false,
        };

        const emailbody = new HttpParams().append(
          'emailbody',
          JSON.stringify(userResponses)
        );
        this.http
          .post(this.url + '/contract/expiry', emailbody)
          .subscribe((notifyres: any) => {
            const result = notifyres ? notifyres : '';
            if (result && result.statusCode === '002') {
            } else {
              this.closeEmailModel(myForm);
              this.signUp();

              document.getElementById('openEmailModalSuucessButton').click();
              console.log('contract Expiry mail sent successfully!!!');
              document.getElementById('closeEmailModelAlign').click();
              this.closeEmailModel(myForm);
              this.signUp();
              this.router.navigateByUrl('/');
              window.sessionStorage.clear();
            }
          });
      }
    }
  }

  hideModal(value) {
    if (value == 'IGNORE AND PROCEED') {
      this.isDisable = false;
      if (this.deviceWidth < 768) {
        this.user_bot = true;
        this.next();
      }
      this.modalRef.hide();
    } else if (value == 'SEND ME A REMINDER') {
      this.isDisable = false;
      this.modalRef.hide();
    } else {
      this.hgContractExpires = {
        value4: false,
        value5: false,
      };
      this.user_bot = false;
      this.isDisable = false;
      this.modalRef.hide();
    }
  }

  onChangeRole(event) {
    this.isChecked = event.target.checked;
    if (this.deviceWidth < 768) {
      this.elem4 = document.getElementById('IgnoreandProceedMob');
      this.elem5 = document.getElementById('SendMeaRemainderMob');
    } else {
      this.elem4 = document.getElementById('IgnoreandProceed');
      this.elem5 = document.getElementById('SendMeaRemainder');
    }
    if (this.isChecked === true) {
      if (event.target.value === 'IGNORE AND PROCEED') {
        this.hgContractExpires = {
          value4: true,
          value5: false,
        };
        this.elem4.parentElement.classList.add('active-select');
        if (_.contains(this.elem5.parentElement.classList, 'active-select')) {
          this.elem5.parentElement.classList.remove('active-select');
        }
        this.ans_in_contract_expires = event.target.value;
      } else if (event.target.value === 'SEND ME A REMINDER') {
        this.hgContractExpires = {
          value4: false,
          value5: true,
        };
        this.elem5.parentElement.classList.add('active-select');
        if (_.contains(this.elem4.parentElement.classList, 'active-select')) {
          this.elem4.parentElement.classList.remove('active-select');
        }
        this.ans_in_contract_expires = event.target.value;
      }
    } else {
      this.hgContractExpires = {
        value4: false,
        value5: false,
      };
      this.elem4.parentElement.classList.remove('active-select');
      this.elem5.parentElement.classList.remove('active-select');
    }
  }

  getSelected() {
    // console.log.log(this.ans_in_contract_expires);
    let result = this.ans_in_contract_expires;
    if (result === 'IGNORE AND PROCEED') {
      this.user_bot = true;
      this.isDisable = false;
      this.hgContract = {
        value1: false,
        value2: false,
        value3: true,
      };
      this.showPicker = false;
      this.date = '';
      this.hgContractExpires = {
        value4: false,
        value5: false,
      };
      this.hideModal(result);
    } else if (result === 'SEND ME A REMINDER') {
      document.getElementById('closeModelAlign').click();
      document.getElementById('openEmailModalButton').click();
      this.hgContract = {
        value1: false,
        value2: false,
        value3: true,
      };
      this.showPicker = false;
      this.date = '';
      this.user_bot = false;
      this.isDisable = false;
      this.hgContractExpires = {
        value4: false,
        value5: false,
      };
    } else {
      this.hgContractExpires = {
        value4: false,
        value5: false,
      };
    }
  }

  // This function is used for to save the data in DB
  save() {
    const Obj = {
      res_question_id: this.data,
      fieldName: 'in_contract',
      fieldValue: this.in_contract,
    };

    this.residentialService.updateResponses(Obj);
  }

  dateObjectCstFormatted(model) {
    return moment(new Date(model)).format('MM/DD/YYYY').toString();
  }
}
